import React from 'react'
import { useIntl } from 'react-intl'
import { css } from '@emotion/css'
import { Text } from '@contrast-security-inc/design-system-typography'
import {
  Dialog,
  BasicDialogBodyWithoutCancel
} from '../../legacy-design-system/modal'

const appListCss = css`
  list-style-type: disc;
  padding-left: 20px;
  margin: 0;
  column-count: 2;
`

const bodyContainerCss = css`
  max-height: 446px;
  overflow-y: auto;
`

const listItemCss = css`
  max-width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-wrap: normal;
`

export function ShowMoreApplicationsModal<TApplication>({
  isOpen,
  applications,
  applicationsContext,
  renderApplication,
  closeDialog
}: {
  isOpen: boolean
  applications: TApplication[]
  applicationsContext: { name: string; type: 'library' | 'server' }
  renderApplication: (application: TApplication) => React.ReactNode
  closeDialog: () => void
}) {
  const intl = useIntl()
  const messageId =
    applicationsContext.type === 'server'
      ? 'title_applicationsOnServer'
      : 'title_applicationsUsingLibrary'

  return (
    <Dialog
      className={css`
        z-index: 1;
      `}
      isOpen={isOpen}
      onCancel={closeDialog}
      renderTitle={() => {
        return (
          <Text font="titleH5" color="neutral100">
            {intl.formatMessage(
              { id: messageId },
              { name: applicationsContext.name }
            )}
          </Text>
        )
      }}
      size="medium"
    >
      <BasicDialogBodyWithoutCancel
        body={
          <div className={bodyContainerCss}>
            <ul className={appListCss}>
              {isOpen &&
                applications.map((item: TApplication, index) => {
                  return (
                    <li key={index} className={listItemCss}>
                      {renderApplication(item)}
                    </li>
                  )
                })}
            </ul>
          </div>
        }
        confirmButtonText={
          <Text font="body" color="white">
            {intl.formatMessage({ id: 'action_close' })}
          </Text>
        }
        onConfirm={closeDialog}
      />
    </Dialog>
  )
}
